import React from 'react';
import { Box, Container, Heading, Text, Button, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';

const MotionBox = motion(Box);

const WhyUsCTA = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.lg">
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box
            p={{ base: 8, md: 12 }}
            bg="white"
            borderRadius="3xl"
            boxShadow="0 20px 60px rgba(0,0,0,0.1)"
            textAlign="center"
          >
            <VStack spacing={6}>
              <Heading size="2xl" fontWeight="900" color="brand.800">
                {data.title}
              </Heading>
              <Text fontSize="lg" color="brand.500" maxW="2xl">
                {data.subtitle}
              </Text>
              <Button
                variant="solid"
                size="lg"
                h="60px"
                px={8}
                as="a"
                href={data.href}
                rightIcon={<FaArrowRight />}
                boxShadow="0 8px 30px rgba(16,185,129,0.4)"
              >
                {data.buttonText}
              </Button>
            </VStack>
          </Box>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default WhyUsCTA;